import {
    // $convertFromMarkdownString,
    // $convertToMarkdownString,
    CHECK_LIST,
    ELEMENT_TRANSFORMERS,
    ElementTransformer,
    // MULTILINE_ELEMENT_TRANSFORMERS,
    TEXT_FORMAT_TRANSFORMERS,
    TEXT_MATCH_TRANSFORMERS,
    TextMatchTransformer,
    Transformer,
} from '@lexical/markdown'
import {
    $createHorizontalRuleNode,
    $isHorizontalRuleNode,
    HorizontalRuleNode,
} from '@lexical/react/LexicalHorizontalRuleNode'
import {
    $createTextNode,
    $isParagraphNode,
    $isTextNode,
    LexicalNode,
} from 'lexical'
import {$createImageNode, $isImageNode, ImageNode} from "../../plugins/image/node/node";
import emojiList from "../../plugins/emoji/emoji-list"
import {
    $createTableNode,
    $isTableNode,
    TableNode,
    TableNode_Cell,
    TableNode_createCell, TableNode_createRow, TableNode_plainTextEditorJSON
} from "../../plugins/table/node/table-node"
import {$createLinkNode, $isLinkNode, LinkNode} from "@lexical/link"

// const debug = "MARKDOWN_TRANSFORMERS"
const debug = false

export const HR: ElementTransformer = {
    dependencies: [HorizontalRuleNode],
    export: (node: LexicalNode) => {
        return $isHorizontalRuleNode(node) ? '***' : null;
    },
    regExp: /^(---|\*\*\*|___)\s?$/,
    replace: (parentNode, _1, _2, isImport) => {
        const line = $createHorizontalRuleNode();

        // TODO: Get rid of isImport flag
        if (isImport || parentNode.getNextSibling() != null) {
            parentNode.replace(line);
        } else {
            parentNode.insertBefore(line);
        }

        line.selectNext();
    },
    type: 'element',
};

export const IMAGE: TextMatchTransformer = {
    dependencies: [ImageNode],
    export: (node: any) => {
        if (!$isImageNode(node)) {
            return null;
        }

        return `![${node.getAltText()}](${node.getSrc()})`;
    },
    importRegExp: /!(?:\[([^[]*)\])(?:\(([^(]+)\))/,
    regExp: /!(?:\[([^[]*)\])(?:\(([^(]+)\))$/,
    replace: (textNode, match) => {
        const [, altText, src] = match;
        const imageNode = $createImageNode({
            altText,
            maxWidth: 800,
            src,
        });
        textNode.replace(imageNode);
    },
    trigger: ')',
    type: 'text-match',
};

export const EMOJI: TextMatchTransformer = {
    dependencies: [],
    export: () => null,
    importRegExp: /:([a-z0-9_]+):/,
    regExp: /:([a-z0-9_]+):$/,
    replace: (textNode, [, name]) => {
        const emoji = emojiList.find((e: any) => e.aliases.includes(name))?.emoji;
        if (emoji) {
            textNode.replace($createTextNode(emoji));
        }
    },
    trigger: ':',
    type: 'text-match',
};

/*export const EQUATION: TextMatchTransformer = {
  dependencies: [EquationNode],
  export: (node: any) => {
    if (!$isEquationNode(node)) {
      return null;
    }

    return `$${node.getEquation()}$`;
  },
  importRegExp: /\$([^$]+?)\$/,
  regExp: /\$([^$]+?)\$$/,
  replace: (textNode, match) => {
    const [, equation] = match;
    const equationNode = $createEquationNode(equation, true);
    textNode.replace(equationNode);
  },
  trigger: '$',
  type: 'text-match',
};*/

/*export const TWEET: ElementTransformer = {
  dependencies: [TweetNode],
  export: (node: any) => {
    if (!$isTweetNode(node)) {
      return null;
    }

    return `<tweet id="${node.getId()}" />`;
  },
  regExp: /<tweet id="([^"]+?)"\s?\/>\s?$/,
  replace: (textNode, _1, match) => {
    const [, id] = match;
    const tweetNode = $createTweetNode(id);
    textNode.replace(tweetNode);
  },
  type: 'element',
};*/

// Very primitive table setup
const TABLE_ROW_REG_EXP = /^(?:\|)(.+)(?:\|)\s?$/;
const TABLE_ROW_DIVIDER_REG_EXP = /^(\| ?:?-*:? ?)+\|\s?$/;

export const TABLE: ElementTransformer = {
    dependencies: [TableNode],
    export: (node: LexicalNode) => {
        return null;

        /*if (!$isTableNode(node)) {
          return null;
        }

        const output: string[] = [];

        for (const row of node.getChildren()) {
          const rowOutput = [];
          if (!$isTableRowNode(row)) {
            continue;
          }

          let isHeaderRow = false;
          for (const cell of row.getChildren()) {
            // It's TableCellNode so it's just to make flow happy
            if ($isTableCellNode(cell)) {
              rowOutput.push(
                $convertToMarkdownString(PLAYGROUND_TRANSFORMERS, cell)
                  .replace(/\n/g, '\\n')
                  .trim(),
              );
              if (cell.__headerState === TableCellHeaderStates.ROW) {
                isHeaderRow = true;
              }
            }
          }

          output.push(`| ${rowOutput.join(' | ')} |`);
          if (isHeaderRow) {
            output.push(`| ${rowOutput.map((_) => '---').join(' | ')} |`);
          }
        }

        return output.join('\n');*/
    },
    regExp: TABLE_ROW_REG_EXP,
    replace: (parentNode, _1, match) => {
        // Header row
        // if header row divider is found then we get previous sibling (table with added row)
        // and mark all its cells as headers
        if (TABLE_ROW_DIVIDER_REG_EXP.test(match[0])) {
            const table = parentNode.getPreviousSibling()
            // if previous sibling is not table then no cells to mark as header, skip
            if (!table || !$isTableNode(table)) {
                return
            }

            // get all rows of table and select last one (before header row divider)
            const rows = table.getRows()
            const lastRow = rows[rows.length - 1]

            // if none found then skip
            if (!lastRow || !lastRow.cells) {
                return
            }

            // Add header state to row cells
            _.map(lastRow.cells, (cell: TableNode_Cell) => {
                // check if it is really cell (all cells have json parameter)
                if (!cell.json) {
                    return
                }

                // change type to 'header'
                cell.type = 'header'
            })

            // header row divider is processed so remove this node
            parentNode.remove()
            return
        }

        // split all match into actual cells (TableNode_Cell[])
        const matchCells: TableNode_Cell[] | null = mapToTableCells(match[0])
        // if there are no cells - skip
        if (matchCells == null) {
            return
        }

        // convert to rows array (single row with cells)
        const rows = [matchCells]
        let sibling = parentNode.getPreviousSibling()
        let maxCells = matchCells.length

        // search for previous siblings if they contain any markdown cells
        while (sibling) {
            // if previous sibling node is not paragraph then - skip
            if (!$isParagraphNode(sibling)) {
                break
            }

            // if previous sibling node has more than one child - skip
            if (sibling.getChildrenSize() !== 1) {
                break
            }

            const firstChild = sibling.getFirstChild()
            // if previous sibling node's first child is not text - skip
            if (!$isTextNode(firstChild)) {
                break
            }

            // convert text content into actual cells (TableNode_Cell[]) if any
            const cells = mapToTableCells(firstChild.getTextContent());
            // if there are no cells - skip
            if (cells == null) {
                break
            }

            // trim cells to max value
            maxCells = Math.max(maxCells, cells.length)

            // add found cells to table rows
            rows.unshift(cells);

            const previousSibling = sibling.getPreviousSibling()

            // remove processed sibling node
            sibling.remove()

            // set another previous sibling node as current and continue loop
            sibling = previousSibling
        }

        // create table node
        const table = $createTableNode([]);

        // add all processed rows into table node
        for (const cells of rows) {
            const tableRow = TableNode_createRow()
            table.getRows().push(tableRow)

            // for each row add its cells
            for (let i = 0; i < maxCells; i++) {
                tableRow.cells.push(i < cells.length ? cells[i] : $createTableCell(''))
            }
        }

        const previousSibling = parentNode.getPreviousSibling()
        // check if previous sibling node is table
        if (
            $isTableNode(previousSibling) &&
            getTableColumnsSize(previousSibling) === maxCells
        ) {
            // if previous sibling node is table then just add processed rows to existing rows
            _.map(table.getRows(), row=>{
                previousSibling.getRows().push(row)
            })

            // and remove processed node
            parentNode.remove()
        } else {
            // if previous sibling node is not table then replace processed node with table node
            parentNode.replace(table)
        }
    },
    type: 'element',
}

function getTableColumnsSize(table: TableNode) {
    const row = table.getRows()[0];
    return row.cells ? row.cells.length : 0;
}

const $createTableCell = (textContent: string): TableNode_Cell => {
    textContent = textContent.replace(/\\n/g, '\n')

    textContent = textContent.replace(/\\/g, '')    // remove all '\' symbols as they are redundant and cause JSON.parse error
                            .replace(/"/g, '\\"')   // escape double quotes

    /*const cell = $createTableCellNode(TableCellHeaderStates.NO_STATUS)
    $convertFromMarkdownString(textContent, PLAYGROUND_TRANSFORMERS, cell)
    cell.exportJSON()
    return TableNode_createCell('normal', cell.exportJSON())*/

    const cellContentString = TableNode_plainTextEditorJSON("\"{0}\"".f(textContent))

    debug && console.log(debug, '$createTableCell cellContentString', textContent, cellContentString)
    debug && console.log(debug, '$createTableCell JSON.parse', JSON.parse(cellContentString))

    return TableNode_createCell('normal', JSON.parse(cellContentString))
}

const mapToTableCells = (textContent: string): Array<TableNode_Cell> | null => {
    const match = textContent.match(TABLE_ROW_REG_EXP);
    if (!match || !match[1]) {
        return null
    }
    return match[1].split('|').map((text) => $createTableCell(text))
}

export const LINK: ElementTransformer = {
    dependencies: [LinkNode],
    export: (node: any) => {
        if (!$isLinkNode(node)) {
            return null
        }

        return `[${node.getTitle()}](${node.getURL()})`
    },
    // regExp: /\[([^\]]*?(?:\!\[[^\]]*\]\([^\)]*\)[^\]]*)*?)\]\(([^)]+)\)$/,
    regExp: /(?:\[([^[]+)\])(?:\((?:([^()\s]+)(?:\s"((?:[^"]*\\")*[^"]*)"\s*)?)\))$/,
    replace: (parentNode, _1, match) => {
        const [, linkText, linkUrl, linkTitle] = match;
        const linkNode = $createLinkNode(linkUrl, {title: linkTitle});
        const linkTextNode = $createTextNode(linkText);
        linkTextNode.setFormat(parentNode.getFormat());
        linkNode.append(linkTextNode);
        parentNode.replace(linkNode);
    },
    type: 'element', // is processed prior to 'text-match'
}

/*export const LINK: TextMatchTransformer = {
    dependencies: [LinkNode],
    export: (node: any) => {
        if (!$isLinkNode(node)) {
            return null;
        }

        return `[${node.getTitle()}](${node.getURL()})`;
    },
    importRegExp: /\[([^\]]*?(?:\!\[[^\]]*\]\([^\)]*\)[^\]]*)*?)\]\(([^)]+)\)/,
    regExp: /\[([^\]]*?(?:\!\[[^\]]*\]\([^\)]*\)[^\]]*)*?)\]\(([^)]+)\)$/,
    replace: (textNode, match) => {
        console.log('!!!LINK', textNode, match)

        const [, altText, src] = match;
        const linkNode = $createLinkNode(src, {
            target: '_blank',
            title: altText
        });

        console.log('!!!LINK linkNode', linkNode)

        textNode.replace(linkNode);
    },
    trigger: ')',
    type: 'text-match',
}*/

// Order of text transformers matters:
//
// - code should go first as it prevents any transformations inside
// - then longer tags match (e.g. ** or __ should go before * or _)
/*export const LINK: TextMatchTransformer = {
    dependencies: [LinkNode],
    export: (node, exportChildren, exportFormat) => {
        if (!$isLinkNode(node)) {
            return null;
        }
        const title = node.getTitle();
        const linkContent = title
            ? `[${node.getTextContent()}](${node.getURL()} "${title}")`
            : `[${node.getTextContent()}](${node.getURL()})`;
        const firstChild = node.getFirstChild();
        // Add text styles only if link has single text node inside. If it's more
        // then one we ignore it as markdown does not support nested styles for links
        if (node.getChildrenSize() === 1 && $isTextNode(firstChild)) {
            return exportFormat(firstChild, linkContent);
        } else {
            return linkContent;
        }
    },
    importRegExp:
        /(?:\[([^[]+)\])(?:\((?:([^()\s]+)(?:\s"((?:[^"]*\\")*[^"]*)"\s*)?)\))/,
    regExp:
        /(?:\[([^[]+)\])(?:\((?:([^()\s]+)(?:\s"((?:[^"]*\\")*[^"]*)"\s*)?)\))$/,
    replace: (textNode, match) => {
        const [, linkText, linkUrl, linkTitle] = match;
        const linkNode = $createLinkNode(linkUrl, {title: linkTitle});
        const linkTextNode = $createTextNode(linkText);
        linkTextNode.setFormat(textNode.getFormat());
        linkNode.append(linkTextNode);
        textNode.replace(linkNode);
    },
    trigger: ')',
    type: 'text-match',
};*/

export const MARKDOWN_TRANSFORMERS: Array<Transformer> = [
    LINK,
    TABLE,
    HR,
    IMAGE,
    EMOJI,
    // EQUATION,
    // TWEET,
    CHECK_LIST,
    ...ELEMENT_TRANSFORMERS,
    // ...MULTILINE_ELEMENT_TRANSFORMERS,
    ...TEXT_FORMAT_TRANSFORMERS,
    ...TEXT_MATCH_TRANSFORMERS,
]
